import { modules } from "./fragments.config";

export const JETBRAINS = modules.typography.fontFamily.classes.jetbrains;
export const POPPINS = modules.typography.fontFamily.classes.poppins;
